import { useEffect } from "react";
import ApresentacaoVideoGate from "./ApresentacaoVideoGate";

export default function ApresentacaoPage() {
  useEffect(() => {
    document.title = "Evolzap — Apresentação";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Conheça o Evolzap — CRM completo com Inteligência Artificial para transformar sua operação."
      );
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <main className="animate-fade-in py-10 md:py-16">
        <ApresentacaoVideoGate />
      </main>
    </div>
  );
}
